const loading = {
	namespaced: true,
	state: {
		statuses: true,
		accounts: true,
		messages: true,
		platforms: true,
		statistics: true,
		createWorkspace: true,
		app: true,
		appReRender: true
	},
	getters: {
		loadingStatuses(state){
			return state.statuses
		},
		loadingAccounts(state){
			return state.accounts
		},
		loadingMessages(state){
			return state.messages
		},
		loadingPlatforms(state){
			return state.platforms
		},
		loadingStatistics(state){
			return state.statistics
		},
		loadingCreateWorkspace(state){
			return state.createWorkspace
		},
		loadingApp(state){
			return state.app
		},
		loadingAppReRender(state){
			return state.appReRender
		}
	},
	mutations: {
		setLoadingStatuses(state, bool){
			state.statuses = bool
		},
		setLoadingAccounts(state, bool){
			state.accounts = bool
		},
		setLoadingMessages(state, bool){
			state.messages = bool
		},
		setLoadingPlatforms(state, bool){
			state.platforms = bool
		},
		setLoadingStatistics(state, bool){
			state.statistics = bool
		},
		setLoadingApp(state, bool){
			state.app = bool
		},
		setLoadingAppReRender(state, bool){
			state.appReRender = (state.appReRender) ? false : true
		}
	},
	actions: {
		setLoadingStatuses({ commit }, bool){
			commit('setLoadingStatuses', bool)	
	},
		setLoadingAccounts({ commit }, bool){
			commit('setLoadingAccounts', bool)
	},
		setLoadingMessages({ commit }, bool){
			commit('setLoadingMessages', bool)
	},
		setLoadingPlatforms({ commit }, bool){
			commit('setLoadingPlatforms', bool)
	},
		setLoadingStatistics({ commit }, bool){
			commit('setLoadingStatistics', bool)
	},
		setLoadingApp({ commit }, bool){
			commit('setLoadingApp', bool)
	},
		setLoadingAppReRender({ commit }, bool){
			commit('setLoadingAppReRender', bool)
	}
}
}

export default loading;


// WEBPACK FOOTER //
// ./src/store/loading.js